// .js (not .ts) because tailwind-breakpoints uses CJS require(); ESM exports below are intentional
const { window: tailwindScreens } = require("../../../config/tailwind/tailwind-breakpoints");

// Derives mobile breakpoint: Tailwind md is min-width 1024px → max-width 1023px
const MOBILE_MEDIA_QUERY = `(max-width: ${Number.parseInt(tailwindScreens.md, 10) - 1}px)`;

export const isMobileViewport = () =>
  globalThis.window?.matchMedia?.(MOBILE_MEDIA_QUERY)?.matches ?? false;

export const canAutoScrollOnLoad = () => !isMobileViewport();
export const canAutoSubmitOnLoad = () => !isMobileViewport();
